<template>
	<div class="pa-6">
		<v-card>
			<v-card-title>
				API запросы
				<v-btn
					icon
					@click="refresh"
					class="ml-3"
				>
					<v-icon>refresh</v-icon>
				</v-btn>
				<v-spacer></v-spacer>
			</v-card-title>

			<a-data-table
				ref="table"
				:headers="headers"
				api-path="logs/get_api"
				disable-sort
			>
				<template v-slot:item.time="{ item }">
					{{ item.timeFormatted }}
				</template>
				<template v-slot:item.execTime="{ item }">
					{{ item.execTime }} мс
				</template>
				<template v-slot:item.success="{ item }">
					<v-icon v-if="+item.success" color="green">
						fiber_manual_record
					</v-icon>
					<v-icon v-else color="red">
						fiber_manual_record
					</v-icon>
				</template>
				<template v-slot:item.actions="{ item }">
					<v-btn
						icon
						class="show-details"
						@click="showDetails(item.id, item.path)">
						<v-icon>
							search
						</v-icon>
					</v-btn>
				</template>
			</a-data-table>
		</v-card>
		<v-dialog
			v-model="dialogMore.show"
			max-width="75%"
			scrollable>
			<v-card
				height="800"
			>
		  		<v-card-title class="headline">
					{{ dialogMore.title }}
					<v-spacer></v-spacer>
					<v-btn icon @click="dialogMore.show = false"><v-icon>close</v-icon></v-btn>
				</v-card-title>
				<v-tabs
					v-model="dialogMore.tab"
					dark
      				grow>
					<v-tabs-slider color="secondary"></v-tabs-slider>

					<v-tab key="headers" href="#headers" >
						Headers
					</v-tab>
					<v-tab key="input" href="#input">
						Input
					</v-tab>
					<v-tab key="output" href="#output">
						Output
					</v-tab>
				</v-tabs>

		        <v-card-text>
					<v-progress-circular
						indeterminate
						v-if="dialogMore.loading"
						color="primary">
					</v-progress-circular>
					<v-tabs-items
						v-else
						vertical
						v-model="dialogMore.tab">
						<v-tab-item
							key="headers"
							value="headers"
							transition="false"
							reverse-transition="false"
							class="pt-4"
						>
							<pre><span v-html="dialogMore.headers"></span></pre>
						</v-tab-item>
						<v-tab-item
							key="input"
							value="input"
							transition="false"
							reverse-transition="false"
							class="pt-4"
						>
							<pre><span v-html="dialogMore.input"></span></pre>
						</v-tab-item>
						<v-tab-item
							key="output"
							value="output"
							transition="false"
							reverse-transition="false"
							class="pt-4"
						>
							<pre><span v-html="dialogMore.output"></span></pre>
						</v-tab-item>
					</v-tabs-items>

		        </v-card-text>
	      	</v-card>
		</v-dialog>
	</div>
</template>

<style scoped>
	.nowrap {
		white-space: nowrap;
	}
	tr .show-details {
		opacity: 0;
	}
	tr:hover .show-details {
		opacity: 1;
	}
	tr.scroll-loading,
	tr.scroll-loading td {
		height: auto;
		border: none;
	}
	.str {
		color: blue;
	}
</style>

<script>
	import aDataTable from '../base/ADataTable.vue'
	import {api} from '../../lib/api'
	import _ from 'lodash'

	export default {
		components: {
			aDataTable
		},
		data: () => ({
			dialogMore: {
				show: false,
				title: '',
				headers: '',
				input: '',
				output: '',
				loading: true,
				tab: 'output'
			},
			headers: [
				{
					text: 'Время запроса',
					value: 'time',
					align: 'center',
					filterable: true,
					filterType: 'dateTime',
				},
				{
					text: 'Пользователь',
					value: 'userName',
					align: 'center',
					filterable: true,
					filterType: 'select',
				},
				{
					text: 'Путь',
					value: 'path',
					align: 'center',
					filterable: true,
					filterType: 'select',
				},
				{
					text: 'Время выполнения',
					value: 'execTime',
					align: 'center',
					filterable: true,
					filterType: 'number',
				},
				{
					text: 'Успех',
					value: 'success',
					align: 'center',
					filterable: true,
					filterType: 'boolean',
				},
				{
					text: '',
					value: 'actions',
					align: 'center',
					filterable: false,
				},
			],
		}),
		methods: {
			refresh() {
				this.$refs.table.clearAndLoad()
			},
			showDetails (id, path) {
				api.post('logs/get_api_details', {
					id: id
				})
				.then(response => {

					this.dialogMore.loading = false

					let tabs = ['input', 'output', 'headers']

					tabs.forEach(tab => {
						this.dialogMore[tab] = JSON.stringify(response.data[tab], null, 2)
						this.dialogMore[tab] = this.dialogMore[tab]
						.replace(/("[^\"]*")([,\s])/gm, '<span style="color: blue;">$1</span>$2')		// строка
						.replace(/(true)([,\s])/gm, '<span style="color: green;">$1</span>$2')			// true
						.replace(/(false)([,\s])/gm, '<span style="color: red;">$1</span>$2')			// false
						.replace(/(null)([,\s])/gm, '<span style="color: grey;">$1</span>$2')			// null
						.replace(/:\s(\d+)/gm, ': <span style="color: brown;">$1</span>')				// число
					})
				}, error => {})
				this.dialogMore.show = true
				this.dialogMore.title = path
				this.dialogMore.loading = true
				this.dialogMore.tab = 'output'
				this.dialogMore.input = ''
				this.dialogMore.output = ''
				this.dialogMore.headers = ''
			},
		}
	}
</script>
